import { useEffect, useState } from "react";
import { parseM3U, type Station } from "./m3u";

const PLAYLIST_URL = "https://iprd-org.github.io/iprd/site_data/all_stations.m3u";

type State =
  | { status: "loading" }
  | { status: "error"; error: string }
  | { status: "ready"; stations: Station[] };

// Shared across mounts so switching routes doesn't download the 5 MB playlist again.
let request: Promise<Station[]> | null = null;

function loadStations(): Promise<Station[]> {
  request ??= fetch(PLAYLIST_URL)
    .then((response) => {
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.text();
    })
    .then(parseM3U)
    .catch((error: unknown) => {
      request = null; // allow a retry on the next mount
      throw error;
    });
  return request;
}

export function useStations(): State {
  const [state, setState] = useState<State>({ status: "loading" });

  useEffect(() => {
    let active = true;

    loadStations()
      .then((stations) => active && setState({ status: "ready", stations }))
      .catch((error: unknown) => {
        if (active) setState({ status: "error", error: error instanceof Error ? error.message : String(error) });
      });

    return () => {
      active = false;
    };
  }, []);

  return state;
}
